/*
 * Created on 11.04.2017.
 *
 * Copyright(c) 1995 - 2017
 * T-Systems Multimedia Solutions GmbH
 * Riesaer Str. 5, 01129 Dresden
 * All rights reserved.
 */

/**
 * Stellt verschiedene Util-Methoden für Dateien bereit.
 */
export class FileUtils {

    /**
     * Privater Konstruktor da nur statische Methoden.
     */
    private constructor() {
        // do nothing
    }

    /**
     * Wandelt Bytes KB, MB, GB, ... um.
     *
     * @param bytes die Anzahl an Bytes
     * @param decimals Anzahl der Nachkommastellen
     * @returns umgewandelter string
     */
    public static formatBytes(bytes: number, decimals?: number): string {
        if (!bytes || isNaN(bytes)) {
            return '0 Bytes';
        }
        if (bytes <= 0) return '0 Bytes';
        const k = 1000;
        const dm = decimals || 2;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return Math.max(+((bytes / Math.pow(k, i)).toFixed(dm)), 0) + ' ' + sizes[i];
    }
}
